import React from "react";
import { Alert, Col, Row, Typography } from "antd";
import { useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";

const { Paragraph, Text } = Typography;

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function Success() {
  let query = useQuery();
  return (
    <Container style={{ width: "100%", paddingTop: "32px" }}>
      <Row justify={"center"}>
        <Alert
          message="Спасибо за Ваш отзыв!"
          description="Нам действительно важно Ваше мнение. Каждый отзыв помогает сделать нашу работу ещё лучше."
          type="success"
          showIcon
        />
      </Row>
      {query.get("ya_org") && (
        <Row justify={"center"}>
          <Col>
            <div style={{ paddingLeft: "16px", paddingTop: "16px", fontSize: "18px" }}>
              Будем признательны, если Вы также поделитесь своим мнением на Яндекс.Картах
            </div>
            <div style={{ paddingLeft: "16px", paddingTop: "16px" }}>
              Это позволит другим пользователям быстрее находить нас и узнавать больше о наших товарах и услугах
            </div>
            {query.get("text") && (
              <div style={{ paddingLeft: "16px", paddingTop: "16px" }}>
                Для удобства вы можете скопировать текст вашего отзыва:
                <Paragraph style={{ maxWidth: "700px" }}>
                  <blockquote style={{ position: "relative", paddingRight: "20px" }}>
                    {query.get("text")}{" "}
                    <Text
                      style={{ position: "absolute", top: 0, right: 0 }}
                      copyable={{ tooltips: ["Нажмите чтобы скопировать", "Скопировано!"], text: query.get("text") }}
                    />
                  </blockquote>
                </Paragraph>
              </div>
            )}

            <div
              style={{ height: "800px", width: "100%", position: "relative", paddingTop: "16px" }}
              dangerouslySetInnerHTML={{
                __html: `<iframe style="width:100%;height:100%;border:1px solid #e6e6e6;border-radius:8px;box-sizing:border-box" src="https://yandex.ru/maps-reviews-widget/${query.get(
                  "ya_org"
                )}?comments"></iframe><a href="https://yandex.ru/maps/org/${query.get("brand")}/${query.get(
                  "ya_org"
                )}/" target="_blank" style="box-sizing:border-box;text-decoration:none;color:#b3b3b3;font-size:10px;font-family:YS Text,sans-serif;padding:0 20px;position:absolute;bottom:8px;width:100%;text-align:center;left:0"></a></div>`,
              }}></div>
          </Col>
        </Row>
      )}
    </Container>
  );
}

export { Success };
